var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPortinariHw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#F4F4F5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.26,18v8H13c4.63,0,7.68-1.74,7.68-5.9s-3.1-6-7.68-6H3.1V10.35h9.63c7.37,0,12.05,3.47,12.05,9.79s-4.68,9.73-12.1,9.73H7.26v6.48H3.1V18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.47,23.35a9.5,9.5,0,1,0-9.53,9.58,9.37,9.37,0,0,0,9.53-9.21,2.29,2.29,0,0,0,0-.37m-23.16,0A13.66,13.66,0,1,1,42.05,36.93h-.11A13.56,13.56,0,0,1,28.31,23.45v-.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.94,10.35h4v5c1.69-3.21,4.85-5.1,9.22-5.1v4.1c-4.69-.1-9.22,2.53-9.22,9.64V36.36h-4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M82.37,2.67v7.68h7.95v4H82.37V28.36c0,4.31,3,5.47,8.21,4.26V36.3c-7.32,1.53-12.21-1.1-12.21-7.58v-26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.16,10.35h4v26h-4Zm-.11-8.21h4.21V6.35H96.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.37,10.35h4v3.74a10.93,10.93,0,0,1,9-4.32c6.42,0,10.58,4.06,10.58,10.58v16h-4V20.82c0-4.52-2.63-7.21-7.21-7.21a8.19,8.19,0,0,0-8.43,7.92c0,.21,0,.41,0,.61V36.36h-4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M159.16,23.35a9.34,9.34,0,0,0-9-9.63h-.58a9.64,9.64,0,1,0,9.63,9.64h0m-23.42,0A13.55,13.55,0,0,1,149.16,9.77a12.4,12.4,0,0,1,10.06,4.74V10.35h4v26h-4V32.2a12.36,12.36,0,0,1-10.06,4.73,13.54,13.54,0,0,1-13.42-13.58"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M170.48,10.35h4v5c1.68-3.21,4.84-5.1,9.21-5.1v4.1c-4.69-.1-9.21,2.53-9.21,9.64V36.36h-4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M187.79,10.35h4v26h-4Zm-.1-8.21h4.21V6.35h-4.21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPortinariHw);
export default __webpack_public_path__ + "static/media/logo-portinari-hw.aae3c1888067960b88607c282c7732a1.svg";
export { ForwardRef as ReactComponent };